(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uniq-constructor"] && !Shopify.designMode) return;
  try {
    
function initUniqBuilders(scope) {
  scope.querySelectorAll('.uniq-builder').forEach(root => {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const chosen=type=>root.querySelector('input[name^="uniq-'+type+'-"]:checked');
    const update=()=>{
      ['tip','handle','bottom'].forEach(type=>{
        const input=chosen(type), target=root.querySelector('[data-preview="'+type+'"]');
        target.replaceChildren();
        if(!input) return;
        if(input.dataset.image){const img=document.createElement('img'); img.src=input.dataset.image; img.alt=input.dataset.title||''; target.append(img);}
        const label=document.createElement('span'); label.textContent=input.dataset.title||''; target.append(label);
      });
    };
    root.addEventListener('change',update);
    root.querySelectorAll('[data-cycle]').forEach(button=>button.addEventListener('click',()=>{
      const options=Array.from(root.querySelectorAll('input[name^="uniq-'+button.dataset.cycle+'-"]')).filter(input=>!input.disabled);
      if(!options.length)return;
      const current=options.findIndex(input=>input.checked);
      const index=(Math.max(current,0)+Number(button.dataset.step)+options.length)%options.length;
      options[index].checked=true;
      options[index].dispatchEvent(new Event('change',{bubbles:true}));
    }));
    update();
    root.querySelector('[data-add]').addEventListener('click',async()=>{
      const button=root.querySelector('[data-add]'), msg=root.querySelector('[data-message]');
      const inputs=['tip','handle','bottom'].map(chosen);
      if(inputs.some(input=>!input)){msg.textContent='Escolha um cabo e uma ponta.';return;}
      button.disabled=true; msg.textContent='A adicionar…';
      try {
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:inputs.map(input=>({id:Number(input.value),quantity:1}))})});
        const data=await response.json();
        if(!response.ok) throw new Error(data.description||'Não foi possível adicionar a combinação.');
        msg.textContent='Combinação adicionada. ';
        const link=document.createElement('a');link.href=(window.Shopify?.routes?.root||'/')+'cart';link.textContent='Ver carrinho';msg.append(link);
      } catch(error){msg.textContent=error.message;} finally{button.disabled=false;}
    });
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initUniqBuilders(document));}else{initUniqBuilders(document);}
document.addEventListener('shopify:section:load',event=>initUniqBuilders(event.target));

  } catch(e) { console.error(e); }
})();
})();
